import { render, staticRenderFns } from "./ExhibitCard.vue?vue&type=template&id=7d63796c&scoped=true&"
import script from "./ExhibitCard.vue?vue&type=script&lang=js&"
export * from "./ExhibitCard.vue?vue&type=script&lang=js&"
import style0 from "./ExhibitCard.vue?vue&type=style&index=0&id=7d63796c&lang=stylus&scoped=true&"
import style1 from "./ExhibitCard.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d63796c",
  null
  
)

export default component.exports